module.exports = __webpack_public_path__ + "img/empty-ads.1aed19e2.svg";